import React from 'react';
import { Link } from 'react-router-dom';

export const Terms = () => {
  const termsData = {
    lastUpdated: "September 6, 2024",
    sections: [
      {
        title: "1. Introduction & Acceptance of Terms",
        content: `Welcome to Namasvi Nexus ("we," "our," "us"). These Terms and Conditions ("Terms") govern your access to and use of our mobile applications, websites, creator tools, wallet coins, and contest participation services. By accessing or using the platform, you agree to be bound by these Terms.`
      },
      {
        title: "2. Eligibility & Account Verification",
        content: `• Age Requirement: You must be at least 18 years of age (or have verified parental/guardian authorization for eligible youth categories).
• Accurate Credentials: You agree to provide true, accurate, and current information during registration.
• Account Security: You are responsible for safeguarding your login credentials and for all activities occurring under your account.`
      },
      {
        title: "3. Platform Use & Community Standards",
        content: `• License: We grant you a revocable, non-exclusive, non-transferable license to access our services in compliance with these Terms.
• Prohibited Activities: You agree not to engage in unauthorized scraping, reverse engineering, distributing malware, creating duplicate bot accounts, or disrupting platform services.`
      },
      {
        title: "4. Digital Coins, Wallet & Purchases",
        content: `• Virtual Currency: Namasvi Wallet Coins are virtual units used exclusively within the platform for event participation, voting, and automation unlocks.
• Non-Transferability: Coins cannot be redeemed for fiat currency outside official contest prize distribution rules.
• Refund Policy: Coin purchases and registration fees are non-refundable once allocated or consumed for an active event.`
      },
      {
        title: "5. User-Generated Content & Intellectual Property",
        content: `• Content Ownership: You retain ownership of videos, photos, and creative works uploaded to the platform.
• Platform License: By submitting content to public events, you grant Namasvi Nexus a royalty-free license to display, promote, and feature your entry across our leaderboard and promotional media.`
      },
      {
        title: "6. Limitation of Liability & Disclaimers",
        content: `Namasvi Nexus is provided on an "as-is" and "as-available" basis. We are not liable for indirect, incidental, or consequential damages resulting from technical interruptions, third-party social media platform outages (e.g. Instagram / Meta API shifts), or unauthorized account access.`
      },
      {
        title: "7. Governing Law & Jurisdiction",
        content: `These Terms shall be governed by and interpreted in accordance with the laws of India, and any disputes shall be subject to the exclusive jurisdiction of the competent courts in Delhi, India.`
      }
    ]
  };

  return (
    <div className="min-h-screen bg-slate-50 text-slate-800 flex flex-col font-sans">
      {/* Top Standalone Header */}
      <header className="bg-white border-b border-slate-200 sticky top-0 z-50 shadow-sm">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 rounded-xl bg-gradient-to-tr from-blue-600 to-indigo-600 flex items-center justify-center text-white font-black text-xl shadow-md shadow-blue-500/20">
              N
            </div>
            <div>
              <span className="text-xl font-extrabold tracking-tight text-slate-900">
                NAMASVI<span className="text-blue-600 font-bold">NEXUS</span>
              </span>
              <span className="hidden sm:inline-block ml-3 px-2.5 py-0.5 text-xs font-semibold bg-blue-50 text-blue-700 rounded-full border border-blue-100">
                Official Legal Portal
              </span>
            </div>
          </div>
          <div className="flex items-center space-x-3 text-sm font-medium">
            <Link to="/privacypolicy" className="text-slate-600 hover:text-slate-900 transition-colors pb-1">Privacy</Link>
            <Link to="/termcondition" className="text-blue-600 font-bold border-b-2 border-blue-600 pb-1">Terms</Link>
            <Link to="/fairpolicy" className="text-slate-600 hover:text-slate-900 transition-colors pb-1">Fair Play</Link>
          </div>
        </div>
      </header>

      {/* Main Content Area */}
      <main className="flex-1 max-w-4xl w-full mx-auto px-4 sm:px-6 py-10">
        <div className="bg-white rounded-3xl p-6 sm:p-12 shadow-sm border border-slate-200/80">
          <div className="border-b border-slate-100 pb-6 mb-8 text-center sm:text-left">
            <span className="inline-block px-3 py-1 bg-blue-50 text-blue-700 text-xs font-bold uppercase tracking-wider rounded-lg mb-3">
              Legal Documentation
            </span>
            <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900 tracking-tight mb-2">
              Terms & Conditions
            </h1>
            <p className="text-sm font-medium text-slate-500">
              Last Updated: <span className="text-slate-700 font-semibold">{termsData.lastUpdated}</span>
            </p>
          </div>

          <div className="space-y-8">
            {termsData.sections.map((section, index) => (
              <div key={index} className="space-y-2">
                <h2 className="text-xl font-bold text-slate-900">
                  {section.title}
                </h2>
                <p className="text-slate-600 leading-relaxed whitespace-pre-line text-sm sm:text-base">
                  {section.content}
                </p>
              </div>
            ))}
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-white border-t border-slate-200 py-6 text-center text-xs text-slate-500">
        <p>© {new Date().getFullYear()} Namasvi Nexus Private Limited. All rights reserved.</p>
      </footer>
    </div>
  );
};
